function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '@shared/components/spzaComponent';
import { mergeStyleSets, MessageBar } from '@fluentui/react';
import { Text } from '@fluentui/react/lib/Text';
const classes = mergeStyleSets({
    warningText: {
        lineHeight: 'normal'
    }
});
class FuturePriceWarning extends SpzaComponent {
    renderImpl() {
        var _this_props_futurePrices_skus, _this_props_futurePrices;
        return !!((_this_props_futurePrices = this.props.futurePrices) === null || _this_props_futurePrices === void 0 ? void 0 : (_this_props_futurePrices_skus = _this_props_futurePrices.skus) === null || _this_props_futurePrices_skus === void 0 ? void 0 : _this_props_futurePrices_skus.length) && /*#__PURE__*/ _jsx(MessageBar, {
            className: "futurePriceMessageBar",
            isMultiline: false,
            children: /*#__PURE__*/ _jsx(Text, {
                className: classes.warningText,
                children: this.context.loc('FuturePrices_warning', 'Please note some prices will be changing. View details below.')
            })
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
export { FuturePriceWarning as default };
FuturePriceWarning.contextTypes = {
    renderErrorModal: PropTypes.func,
    loc: PropTypes.func
};
